var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"puzzle-nav"}},[_c('ul',{staticClass:"nav nav-pills"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{class:_vm.isActive('upload'),attrs:{"to":{
        name: 'create_puzzle'
      }}},[_vm._v("\n        Upload New Puzzle\n      ")])],1),_vm._v(" "),(_vm.puzzleId)?_c('li',{staticClass:"nav-item"},[_c('router-link',{class:_vm.isActive('edit_puzzle'),attrs:{"to":{
        name: 'edit_puzzle',
        params: { puzzleId: _vm.puzzleId }
      }}},[_vm._v("\n        Edit Puzzle\n      ")])],1):_vm._e(),_vm._v(" "),(_vm.purchasableItemId)?_c('li',{staticClass:"nav-item"},[_c('router-link',{class:_vm.isActive('edit_puzzle'),attrs:{"to":{
          name: 'purchasable_item',
          params: {
            purchasableItemId: _vm.purchasableItemId
          }
        }}},[_vm._v("\n        Purchasable Item\n      ")])],1):_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{
          name: 'create_purchasable_item'
        }}},[_vm._v("\n        Create Purchasable Item\n      ")])],1),_vm._v(" "),(!_vm.puzzleId)?_c('li',{staticClass:"nav-item"},[_c('puzzles-options')],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47b1ba26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PuzzleNav.vue
// module id = 1181
// module chunks = 1